import {
  Dashboard,
  Inventory,
  People,
  AccountBalance,
  MoneyOff,
  SportsEsports,
  ManageAccounts,
  Person,
  Link as LinkIcon,
  Settings,
  Psychology as RetentionIcon,
  Stars as PointsIcon,
  Insights as ReferralAnalyticsIcon,
  EmojiEvents as JackpotIcon,
  FactCheck as ReconcileIcon,
} from '@mui/icons-material';
import { ROUTES } from '../../../utils/constants';
import { hasRouteAccess } from '../../../utils/routeUtils';


const MASTER_NAV_ITEMS = [
  // Main
  { id: 'dashboard', label: 'Dashboard', path: ROUTES.DASHBOARD, icon: Dashboard, category: 'Main' },
  { id: 'profile', label: 'Profile', path: ROUTES.PROFILE, icon: Person, category: 'Main' },
  // Business
  { id: 'products', label: 'Products', path: ROUTES.PRODUCTS, icon: Inventory, category: 'Business' },
  { id: 'customers', label: 'Customers', path: ROUTES.CUSTOMERS, icon: People, category: 'Business' },
  // Finance
  { id: 'deposits', label: 'Deposits', path: ROUTES.DEPOSITS, icon: AccountBalance, category: 'Financial' },
  { id: 'withdrawals', label: 'Withdrawals', path: ROUTES.WITHDRAWALS, icon: MoneyOff, category: 'Financial' },
  { id: 'games', label: 'Games', path: ROUTES.GAMES, icon: SportsEsports, category: 'Financial' },
  { id: 'deposit-reconcile', label: 'Deposit Reconcile', path: ROUTES.DEPOSIT_RECONCILE, icon: ReconcileIcon, category: 'Financial' },
  // Admin
  { id: 'users', label: 'User Management', path: ROUTES.USERS, icon: ManageAccounts, category: 'Administration' },
  { id: 'system-settings', label: 'System Settings', path: ROUTES.ADMIN_SETTINGS, icon: Settings, category: 'Administration' },
  { id: 'retention', label: 'Retention', path: ROUTES.RETENTION, icon: RetentionIcon, category: 'Administration' },
  { id: 'points', label: 'Points', path: ROUTES.POINTS, icon: PointsIcon, category: 'Administration' },
  { id: 'jackpot', label: 'Jackpot', path: ROUTES.JACKPOT, icon: JackpotIcon, category: 'Administration' },
  { id: 'referral-analytics', label: 'Referral Analytics', path: ROUTES.REFERRAL_ANALYTICS, icon: ReferralAnalyticsIcon, category: 'Administration' },
  { id: 'referral',  label: 'Referral',  path: ROUTES.REFERRAL,  icon: LinkIcon,  category: 'Main' },
  // { id: 'admin-dashboard', label: 'Admin Dashboard', path: ROUTES.ADMIN_DASHBOARD, icon: AdminPanelSettings, category: 'Administration' },
  // { id: 'system-settings', label: 'System Settings', path: ROUTES.ADMIN_SETTINGS, icon: Settings, category: 'Administration' },
  // // NLA Admin
  // { id: 'nla-dashboard', label: 'NLA Dashboard', path: ROUTES.NLA_ADMIN_DASHBOARD, icon: Security, category: 'NLA' },
  // { id: 'nla-config', label: 'System Config', path: ROUTES.NLA_ADMIN_CONFIG, icon: Settings, category: 'NLA' },
];

export const getDynamicNavigationItems = (userRole) => {
  if (!userRole) return [];
  return MASTER_NAV_ITEMS.filter(item => hasRouteAccess(userRole, item.path));
};

export const getNavigationItemsByCategory = (userRole, category) => {
  const allAccessibleItems = getDynamicNavigationItems(userRole);
  return allAccessibleItems.filter(item => item.category === category);
};

// // ====================================
// // src/components/common/Sidebar/NavigationItems.jsx
// // ====================================
// import React from 'react';
// import {
//   Dashboard,
//   Inventory,
//   People,
//   AccountBalance,
//   MoneyOff,
//   SportsEsports,
//   ManageAccounts,
//   Person,
//   AdminPanelSettings,
//   Settings,
//   Analytics,
//   TrendingUp,
//   Security,
// } from '@mui/icons-material';
// import { ROUTES, USER_ROLES } from '../../../utils/constants';
// import { hasRouteAccess } from '../../../utils/routeUtils';

// const baseNavigationItems = [
//   {
//     id: 'dashboard',
//     label: 'Dashboard',
//     path: ROUTES.DASHBOARD,
//     icon: Dashboard,
//     category: 'main',
//     description: 'Main dashboard overview',
//     allowedRoles: 'all',
//   },
//   {
//     id: 'profile',
//     label: 'Profile',
//     path: ROUTES.PROFILE || '/profile',
//     icon: Person,
//     category: 'main',
//     description: 'User profile and settings',
//     allowedRoles: 'all',
//   },
//   {
//     id: 'products',
//     label: 'Products',
//     path: ROUTES.PRODUCTS,
//     icon: Inventory,
//     category: 'business',
//     description: 'Product management',
//     allowedRoles: [USER_ROLES.JOURNALIST, USER_ROLES.INFLUENCER, USER_ROLES.STATION_MANAGER, USER_ROLES.ADMIN, USER_ROLES.NLA_ADMIN],
//     badge: 'Content',
//   },
//   {
//     id: 'customers',
//     label: 'Customers',
//     path: ROUTES.CUSTOMERS,
//     icon: People,
//     category: 'business',
//     description: 'Customer management',
//     allowedRoles: [USER_ROLES.JOURNALIST, USER_ROLES.INFLUENCER, USER_ROLES.STATION_MANAGER, USER_ROLES.ADMIN, USER_ROLES.NLA_ADMIN],
//   },
//   {
//     id: 'analytics',
//     label: 'Analytics',
//     path: '/analytics',
//     icon: Analytics,
//     category: 'business',
//     description: 'Performance analytics',
//     allowedRoles: [USER_ROLES.STATION_MANAGER, USER_ROLES.ADMIN, USER_ROLES.NLA_ADMIN],
//     isNew: true,
//   },
//   {
//     id: 'deposits',
//     label: 'Deposits',
//     path: ROUTES.DEPOSITS,
//     icon: AccountBalance,
//     category: 'finance',
//     description: 'Deposit management',
//     allowedRoles: [USER_ROLES.STATION_MANAGER, USER_ROLES.ADMIN, USER_ROLES.NLA_ADMIN],
//   },
//   {
//     id: 'withdrawals',
//     label: 'Withdrawals',
//     path: ROUTES.WITHDRAWALS,
//     icon: MoneyOff,
//     category: 'finance',
//     description: 'Withdrawal management',
//     allowedRoles: [USER_ROLES.STATION_MANAGER, USER_ROLES.ADMIN, USER_ROLES.NLA_ADMIN],
//   },
//   {
//     id: 'games',
//     label: 'Games',
//     path: ROUTES.GAMES,
//     icon: SportsEsports,
//     category: 'finance',
//     description: 'Gaming platform management',
//     allowedRoles: [USER_ROLES.STATION_MANAGER, USER_ROLES.ADMIN, USER_ROLES.NLA_ADMIN],
//   },
//   {
//     id: 'financial-reports',
//     label: 'Financial Reports',
//     path: '/reports/financial',
//     icon: TrendingUp,
//     category: 'finance',
//     description: 'Financial reporting and insights',
//     allowedRoles: [USER_ROLES.STATION_MANAGER, USER_ROLES.ADMIN, USER_ROLES.NLA_ADMIN],
//   },
//   {
//     id: 'users',
//     label: 'User Management',
//     path: ROUTES.USERS,
//     icon: ManageAccounts,
//     category: 'admin',
//     description: 'User account management',
//     allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.NLA_ADMIN],
//   },
//   {
//     id: 'admin-dashboard',
//     label: 'Admin Dashboard',
//     path: ROUTES.ADMIN_DASHBOARD || '/admin/dashboard',
//     icon: AdminPanelSettings,
//     category: 'admin',
//     description: 'Administrative dashboard',
//     allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.NLA_ADMIN],
//   },
//   {
//     id: 'system-settings',
//     label: 'System Settings',
//     path: ROUTES.ADMIN_SETTINGS || '/admin/settings',
//     icon: Settings,
//     category: 'admin',
//     description: 'System configuration',
//     allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.NLA_ADMIN],
//   },
//   {
//     id: 'security',
//     label: 'Security Center',
//     path: '/admin/security',
//     icon: Security,
//     category: 'admin',
//     description: 'Security settings and monitoring',
//     allowedRoles: [USER_ROLES.NLA_ADMIN],
//     badge: 'NLA',
//   },
// ];

// export const getDynamicNavigationItems = (userRole) => {
//   if (!userRole) return [];

//   return baseNavigationItems.filter(item => {
//     if (item.allowedRoles === 'all') return true;
    
//     if (Array.isArray(item.allowedRoles)) {
//       return item.allowedRoles.includes(userRole);
//     }
    
//     if (typeof item.allowedRoles === 'string') {
//       return item.allowedRoles === userRole;
//     }
    
//     return false;
//   }).filter(item => {
//     return hasRouteAccess(userRole, item.path);
//   });
// };

// export const getNavigationItemsByCategory = (userRole, category) => {
//   const allItems = getDynamicNavigationItems(userRole);
//   return allItems.filter(item => item.category === category);
// };

// export const getQuickAccessItems = (userRole) => {
//   const quickAccessMap = {
//     [USER_ROLES.JOURNALIST]: ['dashboard', 'products', 'customers', 'profile'],
//     [USER_ROLES.INFLUENCER]: ['dashboard', 'products', 'customers', 'analytics'],
//     [USER_ROLES.STATION_MANAGER]: ['dashboard', 'analytics', 'deposits', 'games'],
//     [USER_ROLES.ADMIN]: ['dashboard', 'users', 'admin-dashboard', 'system-settings'],
//     [USER_ROLES.NLA_ADMIN]: ['dashboard', 'users', 'security', 'system-settings'],
//   };

//   const quickAccessIds = quickAccessMap[userRole] || ['dashboard'];
//   const allItems = getDynamicNavigationItems(userRole);
  
//   return allItems.filter(item => quickAccessIds.includes(item.id));
// };

// export const getRoleInfo = (userRole) => {
//   const roleInfoMap = {
//     [USER_ROLES.JOURNALIST]: {
//       welcome: 'Content Creator Portal',
//       label: 'Journalist',
//       color: 'primary',
//       features: ['Content Management', 'Customer Insights'],
//       primaryActions: ['Create Content', 'View Analytics'],
//     },
//     [USER_ROLES.INFLUENCER]: {
//       welcome: 'Influencer Dashboard',
//       label: 'Influencer',
//       color: 'secondary',
//       features: ['Audience Analytics', 'Content Performance'],
//       primaryActions: ['Track Engagement', 'Manage Campaigns'],
//     },
//     [USER_ROLES.STATION_MANAGER]: {
//       welcome: 'Station Management Hub',
//       label: 'Station Manager',
//       color: 'info',
//       features: ['Financial Control', 'Operations Management'],
//       primaryActions: ['Monitor Finances', 'Manage Operations'],
//     },
//     [USER_ROLES.ADMIN]: {
//       welcome: 'Administrative Control',
//       label: 'Administrator',
//       color: 'warning',
//       features: ['User Management', 'System Control'],
//       primaryActions: ['Manage Users', 'Configure System'],
//     },
//     [USER_ROLES.NLA_ADMIN]: {
//       welcome: 'System Administration',
//       label: 'NLA Admin',
//       color: 'error',
//       features: ['Full System Access', 'Security Management'],
//       primaryActions: ['System Security', 'Global Settings'],
//     },
//   };

//   return roleInfoMap[userRole] || {
//     welcome: 'User Portal',
//     label: userRole,
//     color: 'default',
//     features: ['Basic Access'],
//     primaryActions: ['View Dashboard'],
//   };
// };

// export const getNavigationBadge = (itemId, userRole) => {
//   const badgeMap = {
//     'users': userRole === USER_ROLES.ADMIN ? 3 : null,
//     'deposits': userRole === USER_ROLES.STATION_MANAGER ? 5 : null,
//     'security': userRole === USER_ROLES.NLA_ADMIN ? 1 : null,
//   };

//   return badgeMap[itemId] || null;
// };

// export const navigationItems = getDynamicNavigationItems(USER_ROLES.JOURNALIST);

// export default {
//   getDynamicNavigationItems,
//   getNavigationItemsByCategory,
//   getQuickAccessItems,
//   getRoleInfo,
//   getNavigationBadge,
//   navigationItems,
// };
// // src/components/common/Sidebar/NavigationItems.jsx
// import React from 'react';
// import {
//   Dashboard,
//   Inventory,
//   People,
//   AccountBalance,
//   MoneyOff,
//   SportsEsports,
//   ManageAccounts,
// } from '@mui/icons-material';
// import { ROUTES } from '../../../utils/constants';

// export const navigationItems = [
//   {
//     id: 'dashboard',
//     label: 'Dashboard',
//     path: ROUTES.DASHBOARD,
//     icon: Dashboard,
//   },
//   {
//     id: 'products',
//     label: 'Product Page',
//     path: ROUTES.PRODUCTS,
//     icon: Inventory,
//   },
//   {
//     id: 'customers',
//     label: 'Customer Page',
//     path: ROUTES.CUSTOMERS,
//     icon: People,
//   },
//   {
//     id: 'deposits',
//     label: 'Deposit Page',
//     path: ROUTES.DEPOSITS,
//     icon: AccountBalance,
//   },
//   {
//     id: 'withdrawals',
//     label: 'Withdraw Page',
//     path: ROUTES.WITHDRAWALS,
//     icon: MoneyOff,
//   },
//   {
//     id: 'games',
//     label: 'Games Page',
//     path: ROUTES.GAMES,
//     icon: SportsEsports,
//   },
//   {
//     id: 'users',
//     label: 'User Management',
//     path: ROUTES.USERS,
//     icon: ManageAccounts,
//   },
// ];